<template>
  <transition name="fade">
    <div class="voucher-about">
      <div class="voucher-about-shadow" @click="hideVoucherAboutPopup"></div>
      <div class="voucher-about-main">
        <div class="main-title">
          <div class="main-title-bg"></div>
          <p class="main-title-text">{{ letter.aboutCoins }}</p>
        </div>
        <p class="main-points-tips">
          {{ letter.aboutCoinsText }}
        </p>
        <div
          class="swiper swiper-container voucher-swiper"
          v-if="imgList.length > 0"
        >
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="(item, index) in imgList"
              :key="index"
            >
              <img :src="item" class="slide-img" />
            </div>
          </div>
          <div class="swiper-pagination voucher-pagination"></div>
        </div>
        <a
          href="javascript:;"
          class="get-coupon-btn"
          @click="hideVoucherAboutPopup"
          >{{ letter.known }}</a
        >
        <a
          href="javascript:;"
          class="main-close"
          @click="hideVoucherAboutPopup"
        ></a>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapMutations, mapGetters, mapState } from 'vuex';
import Swiper from 'swiper';
import { SET_VISIBLE_VOUCHER_ABOUT_POPUP } from '@store/officialStore/index';
import showWelfare from '@mixins/officialStore/showWelfare';
import { getGameLanguage } from '@store/officialStore/gameConf';
import { locationType, clickButton } from '@plugins/biPoint/_configWebstoreV1';
export default {
  name: 'voucherAboutPopup',
  mixins: [showWelfare],
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      letter: state => state.letter,
      lang: state => state.lang,
      gameId: state => state.gameId
    }),
    imgList() {
      const imgMap = {
        191: [
          require('@assets/image/officialStore/ztmslg/coin-use-1.jpg'),
          require('@assets/image/officialStore/ztmslg/coin-use-2.jpg')
        ],
        263: [
          require('@assets/image/officialStore/antslg/coin-use-1.jpg'),
          require('@assets/image/officialStore/antslg/coin-use-2.jpg')
        ]
      };
      return imgMap[+this.gameId] || [];
    }
  },
  mounted() {
    this.initSwiper();
  },
  methods: {
    ...mapMutations({
      setVoucherAboutPopup: SET_VISIBLE_VOUCHER_ABOUT_POPUP
    }),
    hideVoucherAboutPopup() {
      this.setVoucherAboutPopup(false);
    },
    initSwiper() {
      try {
        new Swiper('.voucher-swiper', {
          loop: true,
          direction: 'horizontal',
          pagination: {
            el: '.voucher-pagination'
          },
          effect: 'slide',
          observer: true,
          observeParents: true
        });
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/webStore.scss';
.voucher-about {
  z-index: 13;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  &-shadow {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($color: #000000, $alpha: 0.4);
  }
  &-main {
    text-align: center;
    overflow: hidden;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    @psetbg ('voucher-about-popup.png');
  }
  .main {
    &-close {
      position: absolute;
      right: 25px;
      top: 28px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      @psetbg ('close.png');
    }
    &-title {
      margin: 38px 30px 15px;
      position: relative;
      display: flex;
      justify-content: center;
      align-items: center;

      &-bg {
        position: absolute;
        @psetbg ('title-bg-bf.png');
      }
      &-text {
        background-image: -webkit-linear-gradient(
          top,
          var(--voucher-title-color-top),
          var(--voucher-title-color-bottom)
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
        font-family: SourceHanSansSC-Heavy;
        // font-size: 48px;
        font-size: 35px;
        font-weight: bold;
      }
    }

    &-points-tips {
      margin: 0 30px;
      font-size: 16px;
      letter-spacing: 0px;
      color: #ffffff;
    }
  }
  .get-coupon-btn {
    margin-top: 3px;
    width: 282px;
    height: 81px;
    display: inline-block;
    font-family: SourceHanSansSC-Medium;
    font-size: 36px;
    line-height: 81px;
    color: #ffffff;
    @psetbg ('get-coupon-btn-bf.png');
  }
  .swiper-container {
    margin: 19px 41px 10px;
    height: 350px;
    .slide-img {
      height: 321px;
    }
  }
}
</style>
<style lang="scss">
.swiper-pagination-bullet {
  opacity: 1;
  border: none;
  background: var(--voucher-banner) !important;
  &-active {
    background: var(--voucher-banner-actice) !important;
  }
}
</style>
